import React, { useEffect } from "react";
import { FormField } from "../../../helpers/types";
import { FieldData } from "../../../hooks/useForm";
import MultiSelect from "./MultiSelect";
import RadioSelect from "./RadioSelect";
import FileField from "./FileField";
import SetupMultiSelect from "./SetupMultiSelect";
import CheckboxSelect from "./CheckboxSelect";
import UsersMultiSelect from "./UsersMultiSelect";
import { Textarea, TextInput } from "@mantine/core";

function FormInputField({
  label,
  options,
  onChange,
  formData,
  onBlur,
  ...rest
}: FormField) {

  const inputOnChange = (ev: React.FormEvent<HTMLInputElement>) => {
    let { name, value } = ev.currentTarget;
    console.log({ name, value, onChange })
    onChange && onChange({ name, value });
  };
  const checkboxOnChange = (ev: React.FormEvent<HTMLInputElement>) => {
    let { name, value, checked } = ev.currentTarget;
    console.log({ name, value, checked });

    let curVal: any[] = formData?.get(name) || [];
    if (checked) {
      curVal.push(value);
    } else {
      curVal = curVal.filter((val) => val !== value) || [];
    }

    // let newVal = ((rest.choices?.length || 0) > 1) || rest.isMulti ? curVal : curVal.length === 1
    console.log({ curVal });
    onChange && onChange({ name, value: curVal });
  };
  const taOnChange = (ev: React.FormEvent<HTMLTextAreaElement>) => {
    let { name, value } = ev.currentTarget;
    onChange && onChange({ name, value });
  };

  const selectOnChange = (data: FieldData) => {
    onChange && onChange(data);
  };

  const fileOnChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    let { name, files } = ev.currentTarget;
    onChange && onChange({ name, value: files });
  };

  let isRequired = () => {
    if (options?.isRequired) {
      return options?.isRequired(formData);
    }
    return options?.required;
  };

  let required = isRequired();

  let value = formData?.get(rest.name)
  console.log({ name: rest.name, value, formData })

  return (
    <div
      className={
        "relative textfield w-auto p-1" +
        (rest.cols ? ` col-span-2` : "")
      }

      style={rest.extras?.styles || {}}
    >
      {rest.type === "textarea" ? (
        <>
          <Textarea
            id={rest.name}
            value={formData?.get(rest.name)}
            onChange={(e) => taOnChange(e)}
            required={required || undefined}
            name={rest.name}
            label={label || ""}
            readOnly={rest.readOnly}
          />
        </>
      ) : rest.type === "select" ? (
        <MultiSelect
          placeHolder={`Select ${label}`}
          choices={rest.choices || []}
          isMulti={rest.isMulti}
          name={rest.name}
          readOnly={rest.readOnly}
          onChange={selectOnChange}
          formData={formData}
          options={{ ...options, required: required }}
          label={label}
        />
      ) : rest.type === "select_setups" ? (
        <SetupMultiSelect
          placeHolder={`Select ${label}`}
          setupKind={rest.setupKind}
          isMulti={rest.isMulti}
          name={rest.name}
          readOnly={rest.readOnly}
          onChange={selectOnChange}
          formData={formData}
          options={{ ...options, required: required }}
          label={label}
        />
      ) : rest.type === "select_users" ? (
        <UsersMultiSelect
          placeHolder={`Select ${label}`}
          setupKind={rest.setupKind}
          isMulti={rest.isMulti}
          name={rest.name}
          readOnly={rest.readOnly}
          onChange={selectOnChange}
          formData={formData}
          options={{ ...options, required: required }}
          label={label}
        />
      ) : rest.type === "radio" ? (
        <RadioSelect key={`field-${rest.name}`}
          placeHolder={`Select ${label}`}
          choices={rest.choices || []}
          isMulti={rest.isMulti}
          onChange={inputOnChange}
          formData={formData}
          options={{ ...options, required: required }}
          label={label}
          {...rest}
        />
      ) : rest.type === "checkbox" ? (
        <CheckboxSelect
          placeHolder={`Select ${label}`}
          choices={rest.choices || []}
          isMulti={(rest.choices || []).length > 1 || rest.isMulti}
          onChange={checkboxOnChange}
          formData={formData}
          options={{ ...options, required: required }}
          label={label}
          {...rest}
        />
      ) : rest.type === "file" ? (
        <FileField
          formData={formData}
          options={{ ...options, required: required }}
          onChange={fileOnChange}
          label={label}
          {...rest}
        />
      ) : (
        <TextInput key={`field-${rest.name}`}
          type={rest.type || "text"}
          id={rest.name}
          size="sm"
          radius="md"
          label={label || ""}
          placeholder=""
          onChange={inputOnChange}
          defaultValue={formData?.get(rest.name)}
          required={options?.required || undefined}
          readOnly={rest?.readOnly}
          pattern={
            options?.pattern
              ? typeof options.pattern === "function"
                ? options.pattern(formData)
                : options.pattern
              : undefined
          }
          onInput={options?.onInput}
          {...rest}
        />
      )}
    </div>
  );
}

export default FormInputField;
